export const normalizeRange = (metric) => {
    const parsedMetric = JSON.parse(metric);
    return Array.isArray(parsedMetric) ? Math.max(...parsedMetric.map((val) => parseFloat(val))) : parseFloat(metric);
};
